import {
  CoreButton,
  CoreCheckbox,
  CoreModal
} from '@komodo-design-system/komodo-components-react';
import React, { useEffect } from 'react';
import './ProductValidationModal.scss';
import { domParser } from 'utils/utils';

interface ProductValidationModalProps {
  message: string;
  header?: string;
  isModalOpen: boolean;
  handleAction: (action: string, selectedProduct: object) => void;
  cancelText?: string;
  okText?: string;
  inputProps?: object;
  isDisabled?: boolean;
  productList?: any[];
}

function ProductValidationModal({
  isModalOpen,
  handleAction,
  productList
}: ProductValidationModalProps) {
  // console.log('ProductValidationModal', productList);
  const [selectedProduct, setSelectedProduct] = React.useState<any[]>([]);

  useEffect(() => {
    if (isModalOpen) {
      setSelectedProduct([]);
    }
  }, [isModalOpen]);

  const handleSelection = (product: any) => {
    const isSelected =
      selectedProduct.findIndex(
        ({ webId, erp, fcatNum }) =>
          (webId ? webId === product.webId : fcatNum === product.fcatNum) &&
          erp === product.erp
      ) !== -1;
    if (isSelected) {
      setSelectedProduct(
        selectedProduct.filter(
          ({ webId, erp, fcatNum }) =>
            (webId ? webId !== product.webId : fcatNum !== product.fcatNum) &&
            erp !== product.erp
        )
      );
    } else {
      setSelectedProduct([...selectedProduct, product]);
    }
  };

  const getTable = () => {
    //Region/Site	MPN	Root SKU	Vendor Number	Vendor Name	ERP Description/Title
    return (
      <table className="production-modal-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Product SKU</th>
            <th>Region/Site</th>
            <th>MPN</th>
            <th>Root SKU</th>
            <th>Vendor Number</th>
            <th>Vendor Name</th>
            <th>ERP Description/Title</th>
          </tr>
        </thead>
        <tbody>
          {productList?.map((product, index) => (
            <tr key={index}>
              <td>
                <CoreCheckbox
                  onCheckboxChange={() => handleSelection(product)}
                />
              </td>
              <td>{product.webId || product.fcatNum}</td>
              <td>{product.erp}</td>
              <td>{product.mpn}</td>
              <td>{product.rootSku}</td>
              <td>{product.vendorName}</td>
              <td>{product.vnum}</td>
              <td>{domParser(product.productTitle)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <div
      data-testid="product-validation-box"
      className="product-validation-box">
      <CoreModal
        className="product-validation-box-modal"
        data-testid="product-validation-box-modal"
        isopen={isModalOpen}
        bgclose={false}
        closeicon={false}
        header={'Multiple Products Found'}
        subheader="Please highlight the desired product and click Select"
        width={1000}>
        <div className="product-validation-box-content">{getTable()}</div>
        <div className="product-validation-box-buttons">
          <CoreButton
            label={'Select'}
            variant="primary"
            onClick={() => handleAction('YES', selectedProduct)}
            disabled={!selectedProduct.length}
            size="small"
          />
          <CoreButton
            label={'Cancel'}
            variant="outline"
            onClick={() => handleAction('NO', selectedProduct)}
            size="small"
          />
        </div>
      </CoreModal>
    </div>
  );
}

export default ProductValidationModal;


